import { render, staticRenderFns } from "./PhotoTagging.vue?vue&type=template&id=6a608562&scoped=true"
import script from "./PhotoTagging.vue?vue&type=script&lang=js"
export * from "./PhotoTagging.vue?vue&type=script&lang=js"
import style0 from "./PhotoTagging.vue?vue&type=style&index=0&id=6a608562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a608562",
  null
  
)

export default component.exports